import { render, staticRenderFns } from "./assemblyPlanDetail.vue?vue&type=template&id=bcb34dd4&scoped=true&"
import script from "./assemblyPlanDetail.vue?vue&type=script&lang=js&"
export * from "./assemblyPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./assemblyPlanDetail.vue?vue&type=style&index=0&id=bcb34dd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb34dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcb34dd4')) {
      api.createRecord('bcb34dd4', component.options)
    } else {
      api.reload('bcb34dd4', component.options)
    }
    module.hot.accept("./assemblyPlanDetail.vue?vue&type=template&id=bcb34dd4&scoped=true&", function () {
      api.rerender('bcb34dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/loadManagement/assemblyPlanDetail.vue"
export default component.exports